import styles from "../index.module.less"
import { classModuleGenerator } from "@/utils"
const classnames = classModuleGenerator(styles)

function PainPoint(props) {
  return (
    <section className={classnames("painPoint-container")}>
      <div className={classnames("painPoint-img")}>
        <ul className={classnames("painPoint-reason")}>
          <li>成绩一般要分流怎么办？</li>
          <li>没考上高中怎么办？</li>
          <li>上中职能参加高考吗？</li>
          <li>孩子上中专能好好学习吗？</li>
          <li>初中毕业怎么参加高考？</li>
          <li>考不上高中有什么出路？</li>
          <li>读职高技校有没有前途？</li>
          <li>中职考本科有哪几种方式？</li>
        </ul>
      </div>
      {/* <h3 className="section__title">职业教育前景广阔</h3> */}
    </section>
  )
}

export default PainPoint
